import React, { MouseEventHandler } from 'react';
import { StyledHyperLink } from './hyperLink.style';
import parse from 'html-react-parser';
import { TypeKind } from '../Typography/Typography';
import { handleKeyPress } from 'utils/functions';

export interface IHyperLinkProps {
  className?: string;
  kind?: TypeKind;
  label?: string;
  hiddenText?: string;
  style?: React.CSSProperties;
  showArrow?: boolean;
  hasAnimation?: boolean;
  disabled?: boolean;
  align?: 'left' | 'center' | 'right';
  onClick?: () => void;
  onMouseDown?: MouseEventHandler;
  id?: string;
  tabIndex?: number;
}

const HyperLink: React.FC<IHyperLinkProps> = (props) => {
  const { className, kind, label, style, showArrow, hasAnimation, disabled, align, onClick, onMouseDown, id, hiddenText, tabIndex = 0, ...rest } = props;

  return (
     <StyledHyperLink
        id={id}
        kind={kind}
        tabIndex={tabIndex}
        role="link"
        aria-live='polite'
        aria-atomic={true}
        showArrow={showArrow}
        hiddenText={hiddenText}
        hasAnimation={hasAnimation}
        className={className}
        style={style}
        onClick={onClick}
        align={align}
        onMouseDown={onMouseDown}
        disabled={disabled}
        onKeyDown={(e: any) => handleKeyPress(e, 'Enter', onClick)}
        {...rest}
        >
        {parse(label!)}
      </StyledHyperLink>
  )
}

export const defaultProps: IHyperLinkProps = {
  className: '',
  kind: 'regular',
  label: "View More",
  showArrow: false,
  hasAnimation: false,
  style: {},
  disabled: false,
  align: 'left',
  onClick: () => { },
  onMouseDown: () => { }
}

HyperLink.defaultProps = defaultProps

export default HyperLink;